export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M7.488 21.83c-.428.38-1.113.081-1.113-.487v-3.596H4.667C3.194 17.747 2 16.573 2 15.125V4.621C2 3.174 3.194 2 4.667 2h14.666C20.806 2 22 3.174 22 4.621v10.504c0 1.448-1.194 2.622-2.667 2.622h-7.15L7.488 21.83zm.892-6.082V18.5l3-2.752h8.452c.06 0 .103-.022.133-.051a.124.124 0 00.027-.039.076.076 0 00.006-.032V4.12a.076.076 0 00-.006-.032.125.125 0 00-.027-.038.182.182 0 00-.133-.051H4.16a.182.182 0 00-.133.05.125.125 0 00-.028.039.076.076 0 00-.006.032v11.506c0 .015.003.024.006.032.004.01.013.024.028.039.03.029.072.05.133.05h4.22z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};